import CDUploadModalContainer from "./CDUploadModal"

export default CDUploadModalContainer
